import React, { useState } from "react";
import { useEffect } from "react";
import ClassAdministration from "../ClassAdministration";
import StudentAdministration from "../StudentAdministration";
import ProgramAdministration from "../ProgramAdministration";

export default function TeacherAdmin(props) {
  const [currentLevel, setCurrentLevel] = useState();

  useEffect(() => {
    setCurrentLevel(props.level);
  }, [props.level]);

  const renderLevel = () => {
    switch (currentLevel) {
      case "Class":
        //CLASS
        return (
          <ClassAdministration
            teacherInfo={props.teacherInfo}
            schoolInfo={props.schoolInfo}
            classData={props.classData}
            addStudentDropdownOpen={props.addStudentDropdownOpen}
            studentLicenseModalOpen={props.studentLicenseModalOpen}
            newStudentForLicense={props.newStudentForLicense}
            setAddNewStudentToClassModal={props.setAddNewStudentToClassModal}
            toggleStudentDropdown={props.toggleStudentDropdown}
            openAddNewStudentToClassModal={props.openAddNewStudentToClassModal}
            openAddStudentToClassModal={props.openAddStudentToClassModal}
            fullAccessTeacher={props.teacherInfo.data.fullAccess}
          />
        );
      //CLASS END
      case "Student":
        //STUDENT
        return (
          <StudentAdministration
            studentId={props.studentId}
            student={props.student}
            isOpen={props.isOpen}
            updateStudents={props.updateStudents}
            studentHasLicense={props.studentHasLicense}
            classes={props.classes}
            school={props.school}
            schoolInfo={props.schoolInfo}
            teacherInfo={props.teacherInfo.data}
          />
        );
      //STUDENT END
      case "Program":
        //PROGRAM
        return (
          <ProgramAdministration
            programInfo={props.programInfo}
            teacherInfo={props.teacherInfo.data}
            schoolInfo={props.schoolInfo}
          />
        );
      //PROGRAM END
      default:
        return <div></div>;
    }
  };

  return <div>{renderLevel()}</div>;
}
